export default "__VITE_ASSET__BB5$z2h5__"